import { CardContent, Grid } from '@mui/material';

import { Card, InfoField, LinkChip, NO_DATA_PLACEHOLDER } from '@occc-app/design-system';
import { displayAmount } from '@occc-app/lib/currency';
import { routeCreator } from '@occc-app/routes/Location/utils';
import { PurchaseType } from '@occc-app/routes/Transactions/TransactionView/types';
import { purchaseTypeLabelMap } from './transaction-view.constants';

type Props = {
  locationId: string;
  locationSiteId?: string;
  locationName?: string;
  locationAddress: string;
  paidWith?: string;
  time?: string;
  total: number;
  discount?: number;
  purchaseType?: PurchaseType;
  loyaltySequenceId?: string;
  authCode?: string;
  status?: string;
  startedAt?: string;
  completedAt?: string;
  processedAt?: string;
  pointsEarned?: number;
  pointsSpent?: number;
};

export const TransactionViewHeader = (props: Props) => {
  const {
    locationId,
    locationSiteId,
    locationName,
    locationAddress,
    paidWith = NO_DATA_PLACEHOLDER,
    time,
    total,
    discount,
    purchaseType,
    loyaltySequenceId,
    authCode,
    status,
    startedAt,
    completedAt,
    processedAt,
    pointsSpent,
    pointsEarned,
  } = props;

  return (
    <Card
      sx={(theme) => ({
        marginBottom: theme.spacing(1),
      })}
    >
      <CardContent>
        <Grid container spacing={3}>
          {locationName && (
            <Grid item md={3}>
              <InfoField label='Location Name' value={locationName} />
            </Grid>
          )}
          {locationSiteId && (
            <Grid item md={3}>
              <InfoField label='Site ID' value={locationSiteId} />
            </Grid>
          )}
          <Grid item md={3}>
            <InfoField label='Location Address' value={locationAddress} />
          </Grid>
          <Grid item md={3}>
            <InfoField
              label='Location UUID'
              value={
                locationId && (
                  <LinkChip label={locationId} href={routeCreator.generalDetails(locationId)} />
                )
              }
            />
          </Grid>
          {time && (
            <Grid item md={3}>
              <InfoField label='Time' value={time} />
            </Grid>
          )}

          {!!pointsEarned && (
            <Grid item md={3}>
              <InfoField label='Points Earned' value={pointsEarned} />
            </Grid>
          )}
          {!!pointsSpent && (
            <Grid item md={3}>
              <InfoField label='Points Burned' value={pointsSpent} />
            </Grid>
          )}

          <Grid item md={3}>
            <InfoField label='Paid With' value={paidWith} />
          </Grid>
          <Grid item md={3}>
            <InfoField label='Final Amount' value={displayAmount(total, false)} />
          </Grid>
          {discount ? (
            <Grid item md={3}>
              <InfoField label='Total Discount' value={displayAmount(discount, false)} />
            </Grid>
          ) : null}

          {purchaseType && (
            <Grid item md={3}>
              <InfoField label='Purchase Type' value={purchaseTypeLabelMap[purchaseType]} />
            </Grid>
          )}

          {authCode && (
            <Grid item md={3}>
              <InfoField label='Auth Code' value={authCode} />
            </Grid>
          )}
          {status && (
            <Grid item md={3}>
              <InfoField label='Status' value={status} />
            </Grid>
          )}
          {loyaltySequenceId && (
            <Grid item md={3}>
              <InfoField
                label='Loyalty Sequence ID'
                value={loyaltySequenceId}
                sx={{ wordWrap: 'break-word' }}
              />
            </Grid>
          )}
          {startedAt && (
            <Grid item md={3}>
              <InfoField label='Transaction Created' value={startedAt} />
            </Grid>
          )}
          {processedAt && (
            <Grid item md={3}>
              <InfoField label='Processed At' value={processedAt} />
            </Grid>
          )}
          {completedAt && (
            <Grid item md={3}>
              <InfoField label='POS Timestamp' value={completedAt} />
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};
